import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

import { ImageAd, SubmenuItem } from '@/lib/api/navigation/navigation.types'
import Text from '../../text'
import Link from 'next/link'
import NavigationFooter from '../footer'
import { cn } from '@/lib/utils'

interface SubmenuContentProps {
  className?: string
  submenuItems?: SubmenuItem[]
  isFooter?: boolean
  imageAds: ImageAd[]
  setIsOpen: (isOpen: boolean) => void
}
const SubmenuContent = ({
  submenuItems,
  isFooter = true,
  className = '',
  imageAds,
  setIsOpen,
}: SubmenuContentProps) => {
  return (
    <div className={`w-full ${className}`}>
      <Accordion type="single" collapsible>
        {submenuItems &&
          submenuItems.map((subitem, subIndex) => {
            return (
              <AccordionItem
                key={subitem.id}
                value={subitem.name}
                className="border-0 bg-grey-50"
              >
                {subitem.subitems?.length ? (
                  <>
                    <div className="mx-6 border-b-[0.3px] border-primary">
                      <AccordionTrigger
                        className="pb-0 pl-6 pr-1.5 pt-4 text-secondary-900"
                        iconClassName="text-primary-600"
                      >
                        <Text as="p" fontWeight={'normal'} className="py-2">
                          {subitem.name}
                        </Text>
                      </AccordionTrigger>
                    </div>

                    <AccordionContent className="flex flex-col bg-white px-11 py-2">
                      {subitem.subitems?.map((subSubItem, subSubIndex) => {
                        return (
                          <Link
                            key={`NavigationSubSubitem${subSubIndex}`}
                            href={`/product-categories/${subSubItem.slug}`}
                            className="px-1.5 py-2 text-secondary-900 hover:text-primary-600"
                            onClick={() => setIsOpen(false)}
                          >
                            {subSubItem.name}
                          </Link>
                        )
                      })}
                    </AccordionContent>
                  </>
                ) : (
                  <Link
                    className={cn(
                      'mx-6 border-b-[0.3px] border-primary',
                      'flex flex-1 items-center justify-between py-4 pb-0 pl-6 pr-1.5 pt-4 text-secondary-900 transition-all hover:underline [&[data-state=open]>svg]:rotate-180',
                    )}
                    href={`/product-categories/${subitem.slug}`}
                    onClick={() => setIsOpen(false)}
                  >
                    <Text as="p" className="py-2">
                      {subitem.name}
                    </Text>
                  </Link>
                )}
              </AccordionItem>
            )
          })}
      </Accordion>

      {isFooter && <NavigationFooter imageAds={imageAds} />}
    </div>
  )
}

export default SubmenuContent
